module.exports = __webpack_public_path__ + "img/ico_write_long.20d9d0d.svg";